// packages/shared/src/ids.ts
import type { IdPrefix, InviteCode, ItemId, MailId, ObjectId, ResidentId, TownId, VillagerId } from './types/ids';
// Present in Node 22, Workers and browsers (§2.5: no global declarations in shared).
interface CryptoLike { getRandomValues<T extends Uint8Array | Uint32Array>(array: T): T }
const cryptoLike = (globalThis as unknown as { crypto: CryptoLike }).crypto;
export const CROCKFORD = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
export function randomCrockford(n: number): string {
  const bytes = cryptoLike.getRandomValues(new Uint8Array(n));
  let s = '';
  for (const b of bytes) s += CROCKFORD[b & 31];   // 256 is a multiple of 32: uniform
  return s;
}
type IdFor<P extends IdPrefix> = P extends 't' ? TownId : P extends 'r' ? ResidentId : P extends 'i' ? ItemId : P extends 'o' ? ObjectId
  : P extends 'v' ? VillagerId : P extends 'm' ? MailId : string;
export function newId<P extends IdPrefix>(prefix: P): IdFor<P> { return `${prefix}_${randomCrockford(16)}` as IdFor<P>; }
export function newInviteCode(): InviteCode { return randomCrockford(10) as InviteCode; }
